import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cart: {},
    opener: null,
    tokenTemp: '',
    //restApi: "https://api.ar.gtek.mx/dev/",
    restApi: "https://api.ar.gtek.mx/v1/",
    successURL: "https://pay.gtek.mx/#/success/"
    //successURL: "http://ar.payment.dev.s3-website-us-west-2.amazonaws.com/#/success/"
  },
  mutations: {
    STORE_CART: (state, cart) => {
      state.cart = cart;
    },
    STORE_OPENER: (state, opener) => {
      state.opener = opener;
    },
    TOKEN_TEMP: (state, token) => {
      state.tokenTemp = token
    }
  },
  actions: {}
});